
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/indices",
      function () {
        return require("private-next-pages/asset/indices.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/indices"])
      });
    }
  